import { useState, useContext } from "react";
import { Mail, Lock, Eye, EyeOff } from "lucide-react";
import { login } from '../../../Utility/Api';
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { WarehouseContext } from '../../../Utility/UserContext';
import { setLocalStorage } from "../../../Utility/function";

export default function AuthPage() {
  const navigate = useNavigate();
  const { showLoader, hideLoader, setShopItem, setParentCompany } = useContext(WarehouseContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.warn("Please enter both email and password.");
      return;
    }

    setIsLoading(true);
    showLoader();
    try {
      const response = await login({ email, password });
      hideLoader();
      if (response?.data) {
        const token = response?.data?.token;
        const userdetails = JSON.stringify({
          user: response?.data?.data,
          token: token
        });
        setLocalStorage("AuthUser", userdetails);

        toast.success("Login successful!");

        if (response?.data?.data.role_title === 'Super Admin') {
          if (response?.data?.data?.parent_company_id) {
            const usdata = response?.data?.data;
            const shopdata = {
              shop_id: usdata?.shop_id,
              shop_title: usdata?.shop_title,
              email: usdata?.shop_email,
              phone1: usdata?.shop_phone,
            };
            setLocalStorage("SHOP", JSON.stringify(shopdata));
            setParentCompany(response?.data?.data?.parent_company);
            setLocalStorage("ParentCompany", JSON.stringify(response?.data?.data?.parent_company));
          }
          window.location.href = "/dashboard";
        } else {
          const Dataitem = response?.data?.data;
          const entity = {
            shop_id: Dataitem?.shop_id,
            shop_title: Dataitem?.shop_title,
            email: Dataitem?.shop_email,
            Address: Dataitem?.shop_address,
            phone1: Dataitem?.shop_phone,
          };
          const warehouseData = {
            id: 101,
            title: "ZTR - Masala",
            location: "Pernambut",
            manager: "Mohammed"
          };
          setLocalStorage("SHOP", JSON.stringify(entity));
          setLocalStorage("warehouse", JSON.stringify(warehouseData));
          setShopItem(JSON.stringify(entity));
          window.location.href = "/dashboard";
        }
      } else {
        toast.error("Login failed. Please check your credentials.");
      }
    } catch (error) {
      hideLoader();
      console.error("Error during login:", error);
      toast.error(error?.response?.data?.message || "Login failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#fdfdfd] p-4 font-sans">
      <style>
        {`
          .login-input::placeholder {
            color: #64748b !important;
            opacity: 1 !important;
          }
          .login-input {
            border: 1px solid #e2e8f0 !important;
            border-radius: 8px !important;
          }
          .login-button {
            border-radius: 8px !important;
          }
        `}
      </style>
      <div className="w-full max-w-[480px] bg-white rounded-xl border border-slate-200 shadow-sm">
        <div className="pt-8 pb-0 text-center">
          <h1 className="text-[26px] font-bold text-slate-900 mb-2 tracking-tight">ZTR Inventory ERP</h1>
          <p className="text-[15px] text-slate-500">Sign in to your account</p>
        </div>

        <div className="px-6 pb-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2.5">
              <label htmlFor="email" className="text-[14px] font-medium text-slate-700">Email</label>
              <div className="relative">
                <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
                <input
                  id="email"
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="login-input flex h-[46px] w-full bg-white pl-11 pr-3 py-2 text-sm transition-all outline-none focus:border-blue-500"
                  required
                />
              </div>
            </div>

            <div className="space-y-2.5">
              <label htmlFor="password" title="password" className="text-[14px] font-medium text-slate-700">Password</label>
              <div className="relative">
                <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="login-input flex h-[46px] w-full bg-white pl-11 pr-11 py-2 text-sm transition-all outline-none focus:border-blue-500"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="absolute right-3.5 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-700 focus:outline-none"
                  tabIndex={-1}
                >
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="login-button inline-flex items-center justify-center text-[15px] font-bold transition-all bg-[#004785] text-white hover:bg-[#003666] h-[46px] px-4 w-full shadow-sm mt-2"
              disabled={isLoading}
            >
              {isLoading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}
